<template>
  <v-select
    v-bind="[fieldProps, $attrs]"
    :items="items"
    v-model="model"
    name="garagem"
    placeholder="Vagas na Garagem"
    :menu-props="menuProps"
    clearable
    multiple
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>

      <span v-if="index === 1" class="text-body-2 font-weight-regular">
        (+{{ model.length - 1 }})
      </span>
    </template>
  </v-select>
</template>

<script>
import { mixin } from "./mixin";

const _data = {
  model: null,
  items: ["1", "2", "3", "4", "5", "+5"],
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    menuProps() {
      const height = window.innerHeight - 200;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
  },
  watch: {
    $route(v) {
      this.model = v.query.garagem
        ? v.query.garagem.split(",").map((v) => v)
        : null;
    },
  },
  mounted() {
    if (this.$route.query.garagem)
      this.model = this.$route.query.garagem.split(",").map((v) => v);
  },
  mixins: [mixin],
};
</script>
